module.exports = __webpack_public_path__ + "static/About Image 6-de3051f04280f0ecd4318c442255a0c1.jpg";